import type { FormEvent } from 'react';
import { useState } from 'react';
import { Button, Field, TextInput } from '../../components/ui';
import { isApiClientError } from '../../lib/api';

export interface CodeFormProps {
  readonly label: string;
  readonly submitLabel: string;
  /** App codes are 6 digits (numeric keyboard); recovery codes are letters and digits. */
  readonly isAppCode: boolean;
  readonly isPending: boolean;
  readonly error: unknown;
  onSubmit(code: string): void;
}

/** A 401 means the session ended (too many wrong codes): only a new login helps. */
const isSessionEnded = (error: unknown) => isApiClientError(error) && error.status === 401;

const messageOf = (error: unknown) => (error instanceof Error ? error.message : undefined);

/** One code field with its submit button and the server's message under it. */
export function CodeForm({ label, submitLabel, isAppCode, isPending, error, onSubmit }: CodeFormProps) {
  const [code, setCode] = useState('');
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (code.trim()) onSubmit(code.trim());
  };
  if (isSessionEnded(error)) {
    return (
      <div className="flex flex-col gap-3">
        <p role="alert" className="text-danger-fg">
          {messageOf(error)}
        </p>
        <Button type="button" onClick={() => window.location.assign('/auth/login')}>
          Войти заново
        </Button>
      </div>
    );
  }
  return (
    <form className="flex flex-col gap-3" onSubmit={submit}>
      <Field label={label} error={messageOf(error)}>
        <TextInput
          value={code}
          onChange={(event) => setCode(event.target.value)}
          autoComplete="one-time-code"
          inputMode={isAppCode ? 'numeric' : 'text'}
          autoFocus
        />
      </Field>
      <Button type="submit" disabled={isPending || !code.trim()}>
        {submitLabel}
      </Button>
    </form>
  );
}
